import React from 'react';

const SharedWithMe = (props) => {
	return (
		<svg
			version="1.1"
			baseProfile="tiny"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			width={props.width}
			height={props.height}
			xmlSpace="preserve"
			className="pics align-middle mr-1"
			viewBox="0 0 100 100"
		>
			<path fill="#2196F3" d="M94.2,71.4c-3.1-7.6-11.3-11.3-24.8-11.3h-5.8v-7.5c0-0.5-0.4-0.9-0.8-1.3c-0.4-0.4-0.9-0.5-1.4-0.5
                                    c-0.5,0-1,0.2-1.3,0.5L45.4,65.9c-0.3,0.4-0.5,0.8-0.5,1.3c0,0.5,0.2,0.9,0.5,1.3l14.5,14.5c0.3,0.4,0.8,0.5,1.3,0.5
                                    c0.5,0,1.2-0.2,1.5-0.5c0.3-0.4,0.8-0.8,0.8-1.3v-7.5h5.8c1.8,0,3.5,0.2,5,0.3c1.5,0.1,2.9,0.4,4.4,0.7c1.4,0.3,2.7,0.7,3.8,1.2
                                    c1.1,0.5,2.1,1.2,3,2c0.9,0.8,1.7,1.8,2.3,2.9c0.6,1.1,1,2.4,1.4,3.9c0.3,1.5,0.5,3.2,0.5,5.1c0,1,0,2.2-0.1,3.5
                                    c0,0.1,0,0.3-0.1,0.7c0,0.3-0.1,0.6-0.1,0.8c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.4,0.3,0.7,0.3c0.3,0,0.6-0.2,0.8-0.5
                                    c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.2,0.2-0.5,0.4-0.8c0.1-0.3,0.2-0.5,0.3-0.7c2.4-5.4,3.6-9.6,3.6-12.7C95.7,77.1,95.2,74,94.2,71.4z"
			/>
			<path fill="#606060" d="M37.4,44.8c6.2,0,11.5-2.2,15.9-6.6c4.4-4.4,6.6-9.7,6.6-15.8c0-6.2-2.2-11.5-6.6-15.9
                                    C48.8,2.2,43.5,0,37.4,0c-6.2,0-11.5,2.2-15.8,6.6c-4.4,4.4-6.6,9.7-6.6,15.9c0,6.2,2.2,11.5,6.6,15.8
                                    C25.9,42.7,31.2,44.8,37.4,44.8z"/>
			<path fill="#606060" d="M69.4,80.1h0.2v1.5c0,1.9-1.2,3.8-2.6,5.2L66.6,87c-1.4,1.4-3.4,2.1-5.3,2.1c-2,0-3.9-0.8-5.3-2.2L41.4,72.3
                                    c-1.4-1.4-2.1-3.2-2.1-5.2c0-1.9,0.7-3.8,2.1-5.2l0.1-0.1L56,47.4c1.4-1.4,3.3-2.2,5.3-2.2c2,0,4.3,0.8,5.7,2.2
                                    c1.4,1.4,2.6,3.3,2.6,5.2v2.5h-0.2c0.8,0,1.7-0.4,2.5-0.4c-0.8-2.3-1.8-4.5-2.9-6.2c-1.4-2.1-3.2-4-5.5-5.3
                                    c-2.3-1.4-4.9-2.1-7.8-2.1c-5.1,5-11.2,7.4-18.3,7.4c-7.1,0-13.2-2.5-18.3-7.5c-3,0-5.6,0.7-7.8,2c-2.3,1.4-4.1,3.1-5.5,5.2
                                    C4.4,50.5,3.2,53,2.3,56c-0.9,3-1.5,5.9-1.8,8.9c-0.3,3-0.5,6.1-0.5,9.4c0,4.2,1.2,7.6,3.7,10.6c2.5,3.1,5.4,4.3,8.8,4.3h49.9
                                    c3.4,0,6.4-1.2,8.8-4.3c1.2-1.5,2.1-3,2.7-4.8C72.6,80,71.1,80.1,69.4,80.1z"/>
		</svg>
	);
};

export default SharedWithMe;
